import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import { ExTable, ModalButton, SelectionFixedFooter, TableBody, TableHead, TableRow, TableWrapper, useMultipleCheckForm } from 'components/shared/widget'
import { useFetchStocktakingBoxesApi, useFetchStocktakingItemsApi, usePutStocktakingItemApi } from 'api/stocktaking_item'
import { StocktakingItem, StocktakingItemSearchForm } from 'entities/stocktaking_item'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { stocktakingItemColumnInfoList, StocktakingItemTableData } from './stocktaking_item_table'
import { DisplaySetting, TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { Flex } from 'components/shared/flex'
import moment from 'moment'
import { useFetchStocktakingApi, usePutStocktakingApi } from 'api/stocktaking'
import { Alert, Button, ProgressBar } from 'react-bootstrap'

type Props = {
    history: H.History
}

const StocktakingItemsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<StocktakingItemSearchForm>()
    const searchForm = useForm<StocktakingItemSearchForm>({ ...query, ordering: 'probe_box,probe_name', bookCountMin: 1 })
    const api = useFetchStocktakingItemsApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<StocktakingItem>()
    const stocktakingItemDisplaySetting = useDisplaySetting(stocktakingItemColumnInfoList(searchForm), 'StocktakingItem')
    const displaySettings: DisplaySetting[] = [stocktakingItemDisplaySetting]
    const boxesSearchForm = useForm<StocktakingItemSearchForm>({ stocktakingId: query.stocktakingId })
    const boxesApi = useFetchStocktakingBoxesApi(boxesSearchForm)
    const updateApi = usePutStocktakingItemApi()
    const [items, setItems] = useState<StocktakingItem[]>([])
    const stocktakingApi = useFetchStocktakingApi()
    const updateStocktakingApi = usePutStocktakingApi()

    useEffect(() => {
        api.execute()
        stocktakingApi.execute(Number(query.stocktakingId))
    }, [])

    const handleClickRemoveFilter = (key: keyof StocktakingItemSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`stocktaking_items?${queryParams}`)
        }
    }, [searchForm.object])

    useEffect(() => {
        if (api.isSuccess()) {
            setItems([...api.response.results])
            boxesApi.execute()
        }
    }, [api.loading])

    useEffect(() => {
        globalState.setLoading(updateStocktakingApi.loading)
        if (updateStocktakingApi.isSuccess()) {
            stocktakingApi.execute(Number(query.stocktakingId))
        }
    }, [updateStocktakingApi.loading])

    useEffectSkipFirst(() => {
        if (updateApi.isSuccess()) {
            stocktakingApi.execute(Number(query.stocktakingId))
        }
    }, [updateApi.loading])

    return (
        <>
            <ContentHeader
                headerTitle="棚卸し"
                left={
                    <>
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={
                    <div>
                        {!stocktakingApi.response.isCompleted && (
                            <ModalButton
                                disabled={stocktakingApi.response.completedCount !== stocktakingApi.response.bookCount}
                                openButton={<Button disabled={stocktakingApi.response.completedCount !== stocktakingApi.response.bookCount}>締め処理</Button>}
                                modalHeader={<>締め処理</>}
                                modalBody={<div>締め処理を行いますか？</div>}
                                submitButton={
                                    <Button
                                        variant="success"
                                        onClick={() => {
                                            updateStocktakingApi.execute({ ...stocktakingApi.response, isCompleted: true })
                                        }}
                                    >
                                        OK
                                    </Button>
                                }
                            />
                        )}
                    </div>
                }
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                <div>総件数： {api.response.count.toLocaleString()}件</div>
            </Flex>
            {(() => {
                const ratio = Math.round(((stocktakingApi.response.completedCount || 0) / (stocktakingApi.response.bookCount || 1)) * 100)
                return (
                    <div style={{ marginTop: 10 }}>
                        <ProgressBar now={ratio} label={ratio + '%'} />
                    </div>
                )
            })()}
            {stocktakingApi.response.isCompleted && (
                <Alert variant="success" style={{ marginTop: 10 }}>
                    締め処理済みです
                </Alert>
            )}
            <Flex alignItems="center" flexWrap="wrap" style={{ marginTop: 5 }}>
                {boxesApi.response.boxes
                    .sort((a, b) => (a > b ? 1 : -1))
                    .map((box, index) => {
                        if (box === searchForm.object.box) {
                            return (
                                <div key={'stocktaking-item-' + index} style={{ fontSize: 11 }}>
                                    {box}
                                </div>
                            )
                        } else {
                            return (
                                <div
                                    key={box + index}
                                    style={{ fontSize: 11, cursor: 'pointer' }}
                                    className={'linked-text'}
                                    onClick={() => {
                                        searchForm.updateObject('box', box)
                                    }}
                                >
                                    {box}
                                </div>
                            )
                        }
                    })}

                {/* .map((box, index) => {
                        const isIncludes = searchForm.object.box?.split(',')?.includes(box)
                        return (
                            <div
                                key={box + index}
                                style={{ fontSize: 11, cursor: 'pointer' }}
                                className={isIncludes ? '' : 'linked-text'}
                                onClick={() => {
                                    const list = searchForm.object.box?.split(',') ?? []
                                    if (list.includes(box)) {
                                        list.splice(list.indexOf(box), 1)
                                    } else {
                                        list.push(box)
                                    }
                                    searchForm.updateObject('box', list.join(','))
                                }}
                            >
                                {box}
                            </div>
                        )
                    })} */}
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={multipleCheckForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <TableRow>
                                <TableHeads displaySetting={stocktakingItemDisplaySetting} />
                            </TableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={stocktakingItemDisplaySetting.getColumnLength() + 2}>
                            {items.map((stocktakingItem: StocktakingItem) => {
                                return (
                                    <TableRow key={`stocktakingItem-${stocktakingItem.id}`}>
                                        <StocktakingItemTableData
                                            isCompleted={stocktakingApi.response.isCompleted}
                                            stocktakingItem={stocktakingItem}
                                            displaySetting={stocktakingItemDisplaySetting}
                                            onClick={(count: number) => {
                                                const unopenedCount = stocktakingItem.probe?.probeStocks?.filter((p) => !p.openedDate)?.length
                                                if (unopenedCount != count) {
                                                    globalState.showConfirm(
                                                        <div>
                                                            <div>
                                                                入力した実棚数が「{count}本」で現在の未開封数が「{unopenedCount}
                                                                本」なので、
                                                                <a href={`/probe_stocks?probe_name=${stocktakingItem.probe?.name}`}>プローブ在庫画面</a>
                                                                から未開封数を「{count}本」に調整してください
                                                            </div>
                                                        </div>,
                                                        () => {}
                                                    )
                                                } else {
                                                    updateApi.execute({
                                                        id: stocktakingItem.id,
                                                        physicalCount: count,
                                                        completedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
                                                    })
                                                    stocktakingItem.physicalCount = count
                                                    stocktakingItem.completedAt = moment().format('YYYY-MM-DD HH:mm:ss')
                                                }
                                            }}
                                        />
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={multipleCheckForm.ids()}
                onClickReset={() => multipleCheckForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="StocktakingItem"
            ></SelectionFixedFooter>
        </>
    )
}

export default withRouter(StocktakingItemsPage)
